import { isObject, isString, startsWith, extend, omit } from 'lodash';
import debug from 'debug';
import { Resource } from '../resource.js';
const log = debug('itp:core:actions:crud');
function onResponse(response) {
    log('response status=%s; data=%o', response.status, response.data);
    if (isObject(response.data)) {
        return new Resource(response.data);
    }
    return response.data;
}
export class CRUD {
    objectType;
    app;
    constructor(objectType, app) {
        this.objectType = objectType;
        this.app = app;
    }
    static createCRUD(objectType, app) {
        return new CRUD(objectType, app);
    }
    upsert(data, options) {
        const id = data.id;
        if (id == null || (isString(id) && startsWith(id, '$$newrow$$'))) {
            return this.create(omit(data, 'id'), options);
        }
        return this.update(data, options);
    }
    create(data, options) {
        return this.app.connections
            .request(`create_${this.objectType}`, extend({ content: data }, options))
            .then(onResponse);
    }
    update(data, options) {
        let resx = null;
        if (data instanceof Resource) {
            resx = data;
            data = { ...data.getChanges(), id: data.id, etag: data.etag };
        }
        return this.app.connections
            .request(`update_${this.objectType}`, extend({ content: data }, options))
            .then(onResponse);
    }
    delete(data, options) {
        return this.app.connections
            .request(`delete_${this.objectType}`, extend({ content: data }, options))
            .then(onResponse);
    }
}
//# sourceMappingURL=crud.js.map